export default __webpack_public_path__ + "static/media/survey-example-01.f70e6e93.png";